import createAttachments from '../utils/createAttachments';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { CreateAttachmentsProperties } from 'owa-attachment-well-data';
import { clearAttachmentFiles, onDraftEventCreated } from 'owa-calendar-compose-form-actions';
import { orchestrator } from 'satcheljs';

export default orchestrator(onDraftEventCreated, actionMessage => {
    // If the user has not yet picked any file(s) to be added
    // as attachment(s), there is nothing to do
    const store = getComposeStore();
    if (!store.attachmentFiles) {
        return;
    }

    // Create the attachment(s) on the new event
    const { fileList, isInline, shouldShare } = store.attachmentFiles;

    const baseProperties = { isInline, isHiddenInline: false };
    const properties: CreateAttachmentsProperties = shouldShare
        ? { ...baseProperties, shouldShare: true }
        : { ...baseProperties, shouldShare: false };
    createAttachments(fileList, properties);

    // Clear details of attachment files from the store
    clearAttachmentFiles();
});

export { ClientItemId } from 'owa-client-ids';
export { AttachmentFileList } from 'owa-attachment-well-data';
